import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Theme = "light" | "dark" | null;

interface HeaderState {
  theme: Theme;
}

const initialState: HeaderState = {
  theme: null,
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setHeaderTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload;
    },
  },
});

export const { setHeaderTheme } = headerSlice.actions;

export default headerSlice.reducer;
